import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useZinantisMembers } from '../../../contextsProperty/ContextZinantisMembers';
import LoadingMembers from './LoadingMembers';
import MembersFiltersBar from './filters/MembersFiltersBar';
import '../../../../stylesheets/stylesLayout/zinantisMembers.scss';
import IconButton from '../../../../muiComponents/IconButton';
import Tooltip from '../../../../muiComponents/Tooltip';
import MembersTableView from './tableView/MembersTableView';
import MembersCardsView from './cardsView/MembersCardsView';
import useIsMobile from '../../../../customHooks/useIsMobileQuery';
import { getCSSVariable } from '../../../../stylesheets/cssVariablesUtils';
import { useSearchParams } from '../../../../customHooks/useSearchParams';
import MemberPanel from './panel/MemberPanel';
import useTranslate from '../../../../customHooks/useTranslate';

const Members = () => {
    const translate = useTranslate();
    const { updateFilters, isLoading, filters, openedPanelMember } =
        useZinantisMembers();

    const [isTableView, setisTableView] = useState(false);

    useEffect(() => {
        return () => updateFilters('name', '');
    }, []);

    // list overflows on mobile so there will be no table view
    const mobileBreakpoint = parseInt(getCSSVariable('md'));
    const isMobile = useIsMobile(mobileBreakpoint);
    useEffect(() => {
        if (isMobile && isTableView) {
            setisTableView(false);
        }
    }, [isMobile, isTableView]);

    const { removeSearchParam } = useSearchParams({ base64: true });

    const handleClosePanel = () => {
        removeSearchParam('id');
    };

    return (
        <>
            {isLoading ? (
                <LoadingMembers />
            ) : (
                <div className='zinantis-members__page'>
                    <div className='flex flex-column gap-10'>
                        <div className='flex flex-between flex-align-center'>
                            <Typography variant='h1'>
                                {translate('members')}
                            </Typography>
                            {isMobile ? (
                                ''
                            ) : (
                                <Tooltip
                                    titleText={
                                        isTableView
                                            ? 'switch_grid_view'
                                            : 'switch_table_view'
                                    }
                                >
                                    <IconButton
                                        onClick={() =>
                                            setisTableView(!isTableView)
                                        }
                                        iconName={
                                            isTableView
                                                ? 'GridView'
                                                : 'TableChart'
                                        }
                                    />
                                </Tooltip>
                            )}
                        </div>
                        <MembersFiltersBar />
                    </div>
                    {isTableView ? (
                        <MembersTableView />
                    ) : (
                        <MembersCardsView key={filters.connexion} />
                    )}
                </div>
            )}
            {openedPanelMember && (
                <MemberPanel
                    open={openedPanelMember !== undefined}
                    onClose={handleClosePanel}
                    memberId={openedPanelMember.id}
                    status={openedPanelMember.status}
                    statusColor={openedPanelMember.statusColor}
                    statusKey={openedPanelMember.statusKey}
                    memberHotels={openedPanelMember.hotels}
                    allHotels={openedPanelMember.allHotels}
                    connectionRequests={openedPanelMember.connectionRequests}
                />
            )}
        </>
    );
};

export default Members;
